import { FC, Suspense } from "react";
import Home from "src/modules/home";
import { PreLoading } from "src/routes/Loading";

export const HomePage: FC = () => (
  <Suspense fallback={<PreLoading />}>
    <Home />
  </Suspense>
);
